import React from "react";

const number = new Intl.NumberFormat("nl-NL");
const percent = new Intl.NumberFormat("nl-NL", { style: "percent", maximumFractionDigits: 1 });

export function LaunchMemberMixCard({ label, total, newMembers, formerMembers, tone }: {
  label: string;
  total?: number;
  newMembers?: number;
  formerMembers?: number;
  tone: "green" | "brown";
}) {
  const rows = [
    { label: "Nieuw lid", count: newMembers },
    { label: "Voormalig lid", count: formerMembers },
  ];
  return (
    <article className={`stat-card ${tone} launch-member-mix-card`}>
      <span>{label}</span>
      <strong>{total == null ? "-" : number.format(total)}</strong>
      <dl className="launch-member-mix-rows" aria-label={`Verdeling ${label.toLowerCase()} naar eerder lidmaatschap`}>
        {rows.map((row) => (
          <div className="launch-member-mix-row" key={row.label}>
            <dt>{row.label}</dt>
            <dd>{row.count == null ? "-" : number.format(row.count)}</dd>
            <dd>{row.count == null || total == null ? "-" : percent.format(total > 0 ? row.count / total : 0)}</dd>
          </div>
        ))}
      </dl>
    </article>
  );
}
